import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const CASAVI_CONTACT_BLACKLIST_DELETE_RESOURCE = "casavi-contact-blacklist" as const;
export const CASAVI_CONTACT_BLACKLIST_DELETE_API_PATH =
  `/v1/${CASAVI_CONTACT_BLACKLIST_DELETE_RESOURCE}/{uuid}` as const;

export type CasaviContactBlacklistDeleteResponse =
  paths[typeof CASAVI_CONTACT_BLACKLIST_DELETE_API_PATH]["delete"]["responses"][200]["content"]["application/json"];

export const useCasaviContactBlacklistDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<CasaviContactBlacklistDeleteResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.delete<CasaviContactBlacklistDeleteResponse>(
        `/v1/${CASAVI_CONTACT_BLACKLIST_DELETE_RESOURCE}/${uuid}`,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [CASAVI_CONTACT_BLACKLIST_DELETE_RESOURCE],
      });
    },
  });
};
